import cornucopia from './index';
import Projects from './Projects';
import Records from './Records';
import Lock from './Lock';
import Mortgage from './Mortgage';
import Cycle from './Cycle';
import PledgeSetting from './PledgeSetting';
import PledgeRecord from './PledgeRecord';
import Mortgagerecord from './MortgageRecord';
import Mining from './Mining';
import miningBuy from './MiningRecord';
import MiningBonus from './MiningBounsRecord';

export default {
  path: '/home/cornucopia',
  component: cornucopia,
  redirect: '/home/cornucopia/projects',
  children: [
    { path: '/home/cornucopia/projects', component: Projects },
    { path: '/home/cornucopia/records/:cornucopiaId?', component: Records },
    { path: '/home/cornucopia/lock', component: Lock },
    { path: '/home/cornucopia/mortgage', component: Mortgage },
    { path: '/home/cornucopia/cycle', component: Cycle },
    { path: '/home/cornucopia/pledgeSetting', component: PledgeSetting },
    { path: '/home/cornucopia/pledgeRecord', component: PledgeRecord },
    { path: '/home/cornucopia/mortgagerecord', component: Mortgagerecord },
    { path: '/home/cornucopia/mining', component: Mining },
    { path: '/home/cornucopia/miningBuy', component: miningBuy },
    { path: '/home/cornucopia/miningRocord', component: MiningBonus }
  ]
};
